module.exports = "<div class=\"\" *ngIf=\"sharePost\">\r\n    <header></header>\r\n</div>\r\n    <router-outlet></router-outlet>\r\n\r\n\r\n<!--<footer></footer>-->";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/Home/home.component.html
 ** module id = 463
 ** module chunks = 0
 **/